import { render, staticRenderFns } from "./R15.vue?vue&type=template&id=642b6084&scoped=true"
import script from "./R15.vue?vue&type=script&lang=js"
export * from "./R15.vue?vue&type=script&lang=js"
import style0 from "./R15.vue?vue&type=style&index=0&id=642b6084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b6084",
  null
  
)

export default component.exports